import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_route_sheet_status = _resolveComponent("route-sheet-status")!

  return (_ctx.column.key === 'number')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "text-blue-500",
        to: `/new-dispatcher/route-sheet/${_ctx.row.id}`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.row.number), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_ctx.column.key === 'date')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.date)), 1)
        ], 64))
      : (_ctx.column.key === 'courier')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.row.courier)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.row.courier.fullName), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
          ], 64))
        : (_ctx.column.key === 'city')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.row.city)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.row.city.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ], 64))
          : (_ctx.column.key === 'sectors')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_ctx.row.sectors)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.row.sectors, (sector, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: `sector-${i}`
                      }, [
                        (i === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(sector), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" , " + _toDisplayString(sector), 1)
                            ], 64))
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" - ")
                    ], 64))
              ], 64))
            : (_ctx.column.key === 'waves')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_ctx.row.waves)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.row.waves, (wave, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: `wave-${i}`
                        }, [
                          (i === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(wave), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" , " + _toDisplayString(wave), 1)
                              ], 64))
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ], 64))
              : (_ctx.column.key === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    (_ctx.row.status)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_route_sheet_status, {
                            status: _ctx.row.status
                          }, null, 8, ["status"])
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" - ")
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                  ], 64))
}